<template>
  <div class="prevention">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">防疫防治</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBase" filterable placeholder="请选择" size="small" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value || '全部'" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>时间</span>
            <el-date-picker size="small" v-model="start" type="date" placeholder="开始日期" :clearable="false" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions"
              @change="changeTime(0)">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding: 0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding: 0 1px">
            <el-date-picker size="small" v-model="end" type="date" placeholder="结束日期" :clearable="false" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions"
              @change="changeTime(1)">
            </el-date-picker>
          </div>
          <!-- <div class="select-container-box">
            <span>在</span>
            <el-select v-model="type" filterable size="small">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找</span>
            <el-input placeholder="请输入关键字" v-model="keyWord" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" prefix-icon="el-icon-search"
              size="small" class="search-input" clearable>
            </el-input>
          </div> -->
          <el-popover class="pop-condition" placement="bottom" width="580" v-model="popoverVisible" trigger="click">
            <div class="condition">
              <section class="mask">
                <div class="popover-container-box">
                  <span class="popover-label">塘口：</span>
                  <el-input placeholder="请输入" v-model="pondNo" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">周期：</span>
                  <el-input placeholder="请输入" v-model="fishBatch" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <!-- <div class="popover-container-box">
                  <span class="popover-label">产品名称：</span>
                  <el-input placeholder="请输入" v-model="name" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div> -->
                <div class="popover-container-box">
                  <span class="popover-label">负责人：</span>
                  <el-input placeholder="请输入" v-model="leader" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
              </section>
              <div class="comfirm">
                <span @click="popoverVisible = false">关闭</span>
                <span @click="search()">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>
          <audit-status :audit-status.sync="auditStatus" />
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="search()" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
            <!-- <el-button size="small"  type="info" plain @click="batchAuditOrder" class="query" style="width: auto;">批量审核</el-button> -->
            <!-- <el-button size="small"  type="info" plain @click="out" class="outPut">导出</el-button> -->
            <ExportExcelBtn
              apiUrl="/api/Precaution/Export"
              :queryParamsObj="queryParams"
              fileName="防疫防治.xls"
            />
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="preventList.list" style="width: 100%" size="medium" @row-dblclick="dataBackFillGoods" :summary-method="getSummaries" show-summary
          :default-sort="{ prop: 'date', order: 'descending' }">
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column type="expand">
            <template slot-scope="props">
              <c-descriptions>
                <c-descriptions-row v-for="(row, index) in props.row.precautionV2Detalis" :key="index" grid-template-columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr">
                  <c-descriptions-item label="塘口">{{
                    row.pondName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="周期">{{
                    row.batchNo
                  }}</c-descriptions-item>
                  <c-descriptions-item label="药品名称">{{
                    row.productName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="用药方式">{{
                    row.modeName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="用药时间">{{
                    row.dateTimeName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="计量单位">{{
                    row.measureUnit
                  }}</c-descriptions-item>
                  <c-descriptions-item label="供应商名称">{{
                    row.dealerName
                  }}</c-descriptions-item>
                  <c-descriptions-item label="数量">{{
                    row.quantity.toFixed(2)
                  }}</c-descriptions-item>
                  <c-descriptions-item label="成本均价">{{
                    row.price.toFixed(2)
                  }}</c-descriptions-item>
                  <c-descriptions-item label="金额">{{
                    row.amount.toFixed(2)
                  }}</c-descriptions-item>
                </c-descriptions-row>
              </c-descriptions>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="日期" :formatter="formatter" align="center" />
          <el-table-column prop="fishBase" label="基地" show-overflow-tooltip :filters="getBaseFilterList" :filter-method="filterHandler" align="center" />
          <el-table-column prop="pondName" align="center" label="塘口" show-overflow-tooltip />
          <el-table-column prop="totalPrice" show-overflow-tooltip align="center" label="成本均价" :formatter="$formatCellNumberKeepTwo" />
          <el-table-column prop="totalQuantity" label="用量" align="center" :formatter="$formatCellNumberKeepTwo" />
          <el-table-column prop="totalAmount" label="金额" align="center" :formatter="$formatCellNumberKeepTwo" />
          <el-table-column prop="leaderName" align="center" label="负责人" />
          <el-table-column prop="userName" align="center" label="制单人" />
          <el-table-column label="操作" align="center" width="170">
            <template slot-scope="scope">
              <!-- <span class="content-edit" v-if="scope.row.auditStatus === 0" @click="handleAuditStatus(scope.row)">审核</span> -->
              <span class="content-edit" style="margin-left: 20px" @click="handleEdit(scope.$index, scope.row)">{{ edit ? "编辑" : "查看" }}</span>
              <span class="content-del" @click="handleDelete(scope.$index, scope.row)" v-if="edit">删除</span>
              <!-- <span v-if="scope.row.auditStatus !== 0">已审核</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import AuditStatus from "@/components/AuditStatus";
import ExportExcelBtn from "../../common/ExportExcelBtn";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseValueFromList, fishBaseNoPermissionQueryParams } from "@/common/resolveFishBaseSelection.js";
export default {
  name: "preventionManagement",
  mixins: [mixins],
  components: {
    PageChange,
    AuditStatus,
    ExportExcelBtn,
  },
  data () {
    return {
      popoverVisible: false,
      rowId: "",
      num: 20,
      type: "",
      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "pondNo",
          label: "塘口",
        },
        // {
        //   value: "fishBatch",
        //   label: "周期"
        // },
        {
          value: "leader",
          label: "负责人",
        },
      ],

      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      keyWord: "", //查找
      pondNo: "",
      fishBatch: "",
      name: "",
      leader: "",
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      auditStatus: "", //审核状态 0-待审核 1-已审核
      baseList: [], // 基地列表
      fishBase: "", // 基地
    };
  },
  methods: {
    ...mapActions(modules.prevent, [
      "getPreventData", //查询数据
      "getPreventDataV2", //查询数据
      "delPreventDetail", //删除子单
      "delPrevent", //删除主单
    ]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.auditOrder, [
      "auditMaterialOrder",
      "auditPrecautionOrderByMouth",
    ]), // 审核
    //合计显示格式
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if ([4, 5, 6].indexOf(index) === -1) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr.toFixed(2));
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index] + " ";
        } else {
          sums[index] = "--";
        }
      });
      if (!isNaN(sums[5])) {
        sums[5] = parseFloat(sums[5]).toFixed(2);
      }
      if (!isNaN(sums[6])) {
        sums[6] = parseFloat(sums[6]).toFixed(2);
      }

      if (!isNaN(sums[6]) && !isNaN(sums[5]) && sums[5] > 0) {
        sums[4] = (sums[6] / sums[5]).toFixed(2);
      } else {
        sums[4] = "--";
      }

      return sums;
    },
    //存储选中时间
    changeTime (type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    //双击进入编辑页面
    dataBackFillGoods (row, event) {
      // if(row.auditStatus !== 0) return
      this.$router.push({
        name: "addPrevention",
        query: {
          id: row.orderId,
        },
      });
    },
    filterHandler (value, row, column) {
      // 筛选过滤
      const property = column["property"];
      return row[property] === value;
    },
    // 格式化指定列时间
    formatter (row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    //记住基地
    baseChange (e) {
      storage.set("base", e);
    },
    //查询
    search (pageNum) {
      // 设置sessionStorage
      sessionStorage.setItem("preventionKeyword", this.keyWord);
      this.pageInfo.pageNumber = pageNum || 1;

      this.getPreventDataV2(this.queryParams)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
      
      this.popoverVisible = false
    },
    add () {
      //添加
      this.$router.push({
        name: "addPrevention",
        query: {
        },
      });
    },
    handleEdit (index, row) {
      //编辑
      this.$router.push({
        name: "addPrevention",
        query: {
          id: row.orderId,
        },
      });
    },
    //删除
    handleDelete (index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.delPrevent(row.orderId);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          // console.log(err);
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(err.response.data);
        });
    },
    // 审核
    async handleAuditStatus (row) {
      const confirmRes = await this.$confirm("确认审核通过该单据?").catch(
        (err) => err
      );
      if (confirmRes !== "confirm") return;
      await this.auditMaterialOrder({
        id: row.orderId,
        auditStatus: 1,
      }).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.search();
    },
    // 批量审核
    async batchAuditOrder () {
      const confirmRes = await this.$confirm("", "批量操作", {
        confirmButtonText: "批量审核",
        cancelButtonText: "批量驳回",
        center: true,
        distinguishCancelAndClose: true,
      }).catch((err) => err);
      if (confirmRes === "close") return;
      const auditStatus = confirmRes === "confirm" ? 1 : 0;
      const params = {
        auditStatus, // 审核状态 0-待审核 1-已审核 2-审核不通过
        fishBase: this.fishBase, //基地
        ...fishBaseNoPermissionQueryParams(this.baseList),
        startDate: this.start,
        endDate: this.end,
        fishBatch: this.fishBatch, //周期
        pondNo: this.pondNo, //塘口
        leader: this.leader,
        pageIndex: 1, // 当前页数(从1开始)
        pageSize: 10000, // 分页条数
      };
      // if (this.type === "") {
      //   params.fishBase = this.keyWord;
      //   params.fishBatch = this.keyWord;
      //   params.pondNo = this.keyWord;
      //   params.leader = this.keyWord;
      //   params.name = this.keyWord;
      // } else {
      //   params[this.type] = this.keyWord;
      // }
      await this.auditPrecautionOrderByMouth(params).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error",
        });
      });
      this.search();
    },
  },
  async mounted () {
    // 获取基地列表
    this.baseList = await this.getAllBaseList({
      forQueryAll: true,
      allOptionItem: { key: "", value: "" },
    });
    this.fishBase = resolveFishBaseValueFromList(
      this.baseList,
      storage.get("base")
    );
    // // 记住选中基地;
    // let materialPurchaseBase = storage.get("base");
    // let oldBase = this.baseList.find((f) => f.key == materialPurchaseBase);
    // if (oldBase) {
    //   this.fishBaseId = oldBase.key;
    // } else if (this.baseList.length > 0) {
    //   this.fishBaseId = this.baseList[0].key; //默认选中第一个
    // }
    // sessionstorage记住查找关键字
    this.judgeSession("preventionKeyword");
    this.keyWord = this.word;
    this.search();
  },
  //缓存路由组件重新被激活 事件，重新查询列表数据
  activated () {
    this.search(this.pageInfo.pageNumber);
  },
  computed: {
    ...mapState(modules.prevent, ["preventList"]),
    getBaseFilterList () {
      const res = new Map();
      let fiterList = this.preventList.list
        .map((m) => ({
          value: m.fishBase,
          text: m.fishBase,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },

    getPondFilterList () {
      const res = new Map();
      let fiterList = this.preventList.list
        .map((m) => ({
          value: m.fishPondName,
          text: m.fishPondName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getPeriodFilterList () {
      const res = new Map();
      let fiterList = this.preventList.list
        .map((m) => ({
          value: m.fishBatchNo,
          text: m.fishBatchNo,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },

    getLeadingFilterList () {
      const res = new Map();
      let fiterList = this.preventList.list
        .map((m) => ({
          value: m.leaderName,
          text: m.leaderName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    queryParams () {
      return {
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize,
        fishBase: this.fishBase,
        ...fishBaseNoPermissionQueryParams(this.baseList),
        startDate: this.start,
        endDate: this.end,
        pondNo: this.pondNo,
        fishBatch: this.fishBatch,
        leader: this.leader,
        AuditStatus: this.auditStatus,
      };
    },
  },
  //默认时间
  created () {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
};
</script>
<style lang="stylus" scoped>
.pop-condition {
  .more {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 32px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
    border: 1px solid rgba(198, 198, 198, 1);
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
}

.el-popover {
  width: 580px !important;

  .unit {
    display: inline-block;
    line-height: 32px;
    width: 180px;
    text-align: left;
  }

  .condition {
    color: #333;
    font-size: 16px;

    .more {
      height: 32px;
      padding: 0 12px;
      border-radius: 5px;
      line-height: 32px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
      border: 1px solid rgba(198, 198, 198, 1);
    }
  }

  .mask {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 20px 15px 20px;
    z-index: 20;
    font-size: 16px;
    color: #666;
    background: #fff;

    .more {
      margin-left: 20px;
    }

    .popover-container-box {
      width: 260px;
      margin-top: 15px;
      display: flex;

      .popover-label {
        width: 120px;
      }
    }

    .el-input__inner {
      height: 36px;
      width: 180px;
    }

    >div {
      &:nth-child(2n) {
        text-align: right;
        padding-left: 0;

        >span {
          width: 80px;
          text-align: right;
        }
      }
    }
  }

  .comfirm {
    text-align: center;
    font-size: 16px;

    >span {
      display: inline-block;
      width: 100px;
      margin: 15px 0;
      border: 1px solid #BBBBBB;
      border-radius: 4px;
      line-height: 36px;
      background: #fff;
      cursor: pointer;

      &:nth-child(2) {
        margin-left: 20px;
        border: 1px solid #3389FF;
        color: #fff;
        background: #3389FF;
      }
    }
  }
}
</style>

